import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    centerLat: { type: Number, default: 40.4168 },
    centerLng: { type: Number, default: -3.7038 },
    zoom: { type: Number, default: 6.5 },
    title: { type: String, default: 'Location' }
  }

  connect() {
    this.initializeMap()
  }

  initializeMap() {
    this.map = L.map(this.containerTarget, {
      zoomSnap: 0.25,
      zoomDelta: 0.25,
    }).setView([this.centerLatValue, this.centerLngValue], this.zoomValue)

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; OpenStreetMap, &copy; CARTO',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(this.map)

    const spainBounds = [
      [43.79, -9.39],
      [36.00, 4.32]
    ]

    this.map.fitBounds(spainBounds)

    this.centerMarker = L.marker([this.centerLatValue, this.centerLngValue])
      .addTo(this.map)
      .bindPopup(this.titleValue)
  }
}
